import React from 'react';
import { FixedHeaderFooterContainer, FixedHeaderFooterHeader, FixedHeaderFooterBody, FixedHeaderFooterFooter } from './FixedHeaderFooterLayout.Styled';
export const FixedHeaderFooterLayout = (props) => {
    const { headerComponent, bodyComponent, footerComponent } = props;
    return (React.createElement(FixedHeaderFooterContainer, null,
        headerComponent && React.createElement(FixedHeaderFooterHeader, null, headerComponent),
        bodyComponent && React.createElement(FixedHeaderFooterBody, null, bodyComponent),
        footerComponent && React.createElement(FixedHeaderFooterFooter, null, footerComponent)));
};
//# sourceMappingURL=FixedHeaderFooterLayout.js.map